__turbopack_context__.v({
  "hideshow": "star-module-scss-module__3ovEma__hideshow",
  "starCliPath": "star-module-scss-module__3ovEma__starCliPath",
  "starG": "star-module-scss-module__3ovEma__starG",
  "starG-3quarter": "star-module-scss-module__3ovEma__starG-3quarter",
  "starG-empty": "star-module-scss-module__3ovEma__starG-empty",
  "starG-full": "star-module-scss-module__3ovEma__starG-full",
  "starG-half": "star-module-scss-module__3ovEma__starG-half",
  "starG-quarter": "star-module-scss-module__3ovEma__starG-quarter",
  "starPath": "star-module-scss-module__3ovEma__starPath",
});
